"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import FooterWrapper from "@/components/footer/FooterWrapper";
import MobileLayout from "@/components/layout/MobileLayout";
import SmallScreenLayout from "@/components/layout/SmallScreenLayout";
import WebLayout from "@/components/layout/WebLayout";
import LayoutErrorFallback from "@/components/providers/LayoutErrorFallback";
import { SIDEBAR_MOBILE_BREAKPOINT } from "@/constants/sidebar";
import { useGlobalRefresh } from "@/contexts/RefreshContext";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import type { ComponentType, ReactNode } from "react";
export default function LayoutWrapper(t0) {
  const $ = _c(16);
  const {
    children
  } = t0;
  const {
    isApp,
    hasTouchScreen
  } = useDeviceInfo();
  const {
    refreshKey
  } = useGlobalRefresh();
  const isSmallScreen = useIsMobileScreen();
  const [isTouchTabletViewport, setIsTouchTabletViewport] = useState(_temp);
  const pathname = usePathname();
  let t1;
  let t2;
  if ($[0] !== hasTouchScreen) {
    t1 = () => {
      if (!hasTouchScreen) {
        setIsTouchTabletViewport(false);
        return;
      }
      const browserWindow = globalThis.window;
      if (browserWindow === undefined) {
        setIsTouchTabletViewport(false);
        return;
      }
      const mediaQuery = browserWindow.matchMedia(`(max-width: ${SIDEBAR_MOBILE_BREAKPOINT - 0.02}px)`);
      setIsTouchTabletViewport(mediaQuery.matches);
      const listener = event => {
        setIsTouchTabletViewport(event.matches);
      };
      if (typeof mediaQuery.addEventListener === "function") {
        mediaQuery.addEventListener("change", listener);
        return () => {
          mediaQuery.removeEventListener?.("change", listener);
        };
      }
      const previousOnChange = mediaQuery.onchange;
      mediaQuery.onchange = listener;
      return () => {
        if (mediaQuery.onchange === listener) {
          mediaQuery.onchange = previousOnChange ?? null;
        }
      };
    };
    t2 = [hasTouchScreen];
    $[0] = hasTouchScreen;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const isAccessOrRestricted = pathname?.startsWith("/access") || pathname?.startsWith("/restricted");
  let LayoutComponent = WebLayout;
  const isSmallLayout = hasTouchScreen && (isSmallScreen || isTouchTabletViewport);
  if (isApp) {
    LayoutComponent = MobileLayout;
  } else {
    if (isSmallLayout) {
      LayoutComponent = SmallScreenLayout;
    }
  }
  if (isAccessOrRestricted) {
    let t3;
    if ($[3] !== children) {
      t3 = <>{children}</>;
      $[3] = children;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t3;
  if ($[5] !== pathname || $[6] !== refreshKey) {
    t3 = [pathname, refreshKey];
    $[5] = pathname;
    $[6] = refreshKey;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FooterWrapper />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== children || $[10] !== refreshKey || $[11] !== t3) {
    t5 = <ErrorBoundary key={refreshKey} FallbackComponent={LayoutErrorFallback} resetKeys={t3}>{children}{t4}</ErrorBoundary>;
    $[9] = children;
    $[10] = refreshKey;
    $[11] = t3;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== LayoutComponent || $[14] !== t5) {
    t6 = <LayoutComponent>{t5}</LayoutComponent>;
    $[13] = LayoutComponent;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
function _temp() {
  if (globalThis.window === undefined) {
    return false;
  }
  return globalThis.window.innerWidth < SIDEBAR_MOBILE_BREAKPOINT;
}